import { Flex, Text } from '@chakra-ui/react';
import { IReviewerFeedback } from '@publishing-engine/domain/models';
import MultilineText from 'src/components/MultilineText';
import { EditorialAttachments } from './EditorialAttachments';

export const ReviewerFeedback = ({
  reviewerFeedback = [],
  submissionContextId
}: {
  reviewerFeedback?: IReviewerFeedback[];
  submissionContextId: string;
}) => {
  return reviewerFeedback.map(
    ({ comment, attachments, reviewId, reviewerInformation = {} }, index) => (
      <Flex key={reviewId} gap={2} mt={2} flexDirection={'column'}>
        <Text textStyle="headingLine">
          Feedback from Reviewer {index + 1}
          {reviewerInformation.firstName && (
            <>
              {' ('}
              {reviewerInformation.firstName} {reviewerInformation.lastName}
              {')'}
            </>
          )}
        </Text>
        <MultilineText textStyle="textBody" text={comment} />
        <EditorialAttachments
          attachments={attachments}
          submissionContextId={submissionContextId}
        />
      </Flex>
    )
  );
};
